// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FHcr","buttons":"styles_buttons__2bhcL"};